import i18n from '../../i18n';

export default {
  date: 'تاریخ',
  baseLine: 'حد پایین',
  target: 'حد مطلوب',
  areYouSureToRemoveTheCheckPoint: 'آیا از حذف این هدف اطمینان دارید؟',
  splitPerDistinctive: (name: string) => {
    return i18n.t('splitPerDistinctive', { ns: 'survey', name });
  },
};
